import { Card } from "antd";

const PageWrapper = ({ children, className }) => (
  <Card
    className={className}
    bordered={false}
    style={{
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
      borderRadius: "16px",
      background: "rgba(255, 255, 255, 0.95)",
      backdropFilter: "blur(10px)",
      border: "2px solid rgba(0, 0, 255, 0.2)",
    }}
    bodyStyle={{ padding: "24px" }}
  >
    {children}
  </Card>
);

export default PageWrapper;
